<template>
  <div>
    <div class="row mt_16">
      <div class="col create_title">帳戶比例配置約定</div>
    </div>
    <div class="d-flex mt_25">
      <div class="mr_3">
        <strong style="line-height: 40px">假設指數報酬率:</strong>
      </div>
      <div class="position-relative">
        <div class="notice-top text-red"></div>
        <div class="d-flex">
          <div class="d-flex mr_10 align-items-center">
            <input
              type="number"
              step="0.1"
              class="form-control mr_2 ml_2"
              style="width: 7rem"
              @input="floatHandler(productDataScope, 'ratio1')"
              v-model="productDataScope.ratio1"
              :class="{ 'is-invalid': errors.has('ratio1') }"
              :data-vv-name="'ratio1'"
              data-vv-as="假設投資報酬率"
              v-validate.continues="`required|ratio1`"
              placeholder="-25~25"
            />%
          </div>
        </div>
      </div>
    </div>
    <InventmentAllocation
      :inventmentAllocationProp.sync="fundAllocation"
      :validTotal100Text="`配置比例需以${
        PRODUCT_FEATURE_DATA.fund_rato || 25
      }%為單位，且固定帳戶及指定帳戶配置比例分開計算，各自合計需為100%!`"
      ref="InventmentAllocation"
    />
  </div>
</template>

<script>
import mf_Mixin from "@/desktop/views/mf/mixin";
import InventmentAllocation from "./InventmentAllocation.vue";

import { Validator } from "vee-validate";
import _ from "lodash";
export default {
  props: ["productDataScope", "mainIndex"],
  components: { InventmentAllocation },
  mixins: [mf_Mixin],
  created() {
    this.initValidator();
  },
  computed: {
    fundAllocation: {
      get() {
        return this.productDataScope.fund
          ? this.productDataScope.fund.fund
          : [];
      },
      set(val) {
        if (this.productDataScope.fund) {
          this.productDataScope.fund.fund = val;
        }
      },
    },
    MfEditing() {
      return this.$store.getters.MfEditing;
    },
    PRODUCT_FEATURE_DATA() {
      return this.MfEditing.mc_prod_list[0].FEATURE_DATA;
    },
  },

  methods: {
    initValidator() {
      Validator.extend(`ratio1`, {
        getMessage: "",
        validate: (value) => {
          return value >= -25 && value <= 25 && (value * 10) % 1 == 0;
        },
      });
    },
    async validateAll() {
      //檢核上方輸入框與投資比例分配
      let VaildInput = await this.$validator.validateAll();
      let vaildInventment = await this.$refs[
        "InventmentAllocation"
      ].validateAll();
      return VaildInput && vaildInventment;
    },
  },
  watch: {
    "productDataScope.ratio1": {
      handler() {
        this.productDataScope.ratio2 = "";
        this.productDataScope.ratio3 = "";
        this.productDataScope.ratio4 = "";
      },
      immediate: true,
    },
  },
};
</script>

<style></style>
